const UNLOCK_TIMEOUT_MS = 1000;
const BLUR_DELAY_MS = 100;
const VISIBILITY_DELAY_MS = 200;
const CANCEL_THRESHOLD_MS = 500;

export default class DialogController {
  #isLocked = false;

  #timers = new Set();

  #dialogOpenTime = 0;

  #destroyed = false;

  // Getters
  get isLocked() {
    return this.#isLocked;
  }

  get destroyed() {
    return this.#destroyed;
  }

  // Actions
  lockInput() {
    this.#isLocked = true;
  }

  unlock() {
    this.#isLocked = false;
    this.#timers.forEach(timer => clearTimeout(timer));
    this.#timers.clear();
  }

  addTimer(timer) {
    this.#timers.add(timer);
  }

  canHandleClick() {
    return !this.#destroyed && !this.#isLocked;
  }

  setupUnlockFallback() {
    const timer = setTimeout(() => this.unlock(), UNLOCK_TIMEOUT_MS);
    this.#timers.add(timer);
  }

  handleFocus() {
    this.#dialogOpenTime = Date.now();
  }

  handleBlur() {
    const timer = setTimeout(() => this.unlock(), BLUR_DELAY_MS);
    this.#timers.add(timer);
  }

  handleVisibilityChange() {
    if (document.hidden || !this.#isLocked) return;

    const dialogDuration = Date.now() - this.#dialogOpenTime;
    if (dialogDuration < CANCEL_THRESHOLD_MS) {
      const timer = setTimeout(() => {
        if (this.#isLocked) this.unlock();
      }, VISIBILITY_DELAY_MS);
      this.#timers.add(timer);
    }
  }

  setupFileDialogListeners($input) {
    $input.addEventListener("focus", this.onFileDialogFocus.bind(this), { once: true });
  }

  destroy() {
    if (this.#destroyed) return;

    this.#timers.forEach(timer => clearTimeout(timer));
    this.#timers.clear();

    this.#destroyed = true;
  }

  // Inits
  onFileDialogFocus() {
    this.handleFocus();
  }

  #onFileDialogCancel() {
    this.unlock();
  }
}
